import React, { Fragment, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import '../../Styles/Common.css'
import { Select,
    SelectItem,
    SelectTrigger,
    SelectValue,
    SelectContent } from './select'
import { Controller, useForm } from 'react-hook-form'

const DropdownTextInput = ({ value, onValueChange, name = '', control, rules, placeholder, label, required, key, errors, setError, clearErrors, disabled }) => {
    const [ textValue, setTextValue ] = useState('')
    const [ dropdownValue, setDropdownValue ] = useState('Mr. ')
    const { control: formControl } = useForm()

    useEffect(() => {
        const titleRegex = /^(Mr\.|Mrs\.|Ms\.|Mx\.|Dr\.)/i
        const match = titleRegex.exec(value)

        if (match) {
          const title = match[1] + ' '
          const name = value.slice(title.length)          
          setDropdownValue(title)
          setTextValue(name)
          if (name?.length === 0) {
            onValueChange('')
          }
        } else {
          setDropdownValue('Mr. ')
          setTextValue(value || '')
        }
    }, [value])
    const onChangeValue = (value, isDropdown) => {
        if (isDropdown) {
            setDropdownValue(value)
            if (textValue?.length === 0) {
                onValueChange('')
            } else {
                onValueChange(value + textValue, name)
            }
        } else {
            setTextValue(value)
            onValueChange(dropdownValue + value, name)
        }
    }
  return (
    <Fragment>
        {label && <label className='grc-label block mb-1'>{label}{required && <span className='text-danger'>*</span>}</label>}
        <div className='relative'>
            <Controller
                name={name}
                control={control || formControl}
                rules={rules}
                render={({ field: { onChange, onBlur } }) => (
                    <input
                    onChange={({ target: { value } }) => { onChangeValue(value, false); onChange(value)}}
                    disabled={disabled}
                    onBlur={async (e) => {
                        if (label === 'First Name') {
                            const titleRegex = /^(Mr\.|Mrs\.|Ms\.|Mx\.|Dr\.)\s*/i
                            const nameWithoutTitle = value?.replace(titleRegex, '').trim();
                            if (nameWithoutTitle?.length > 50) {
                                setError?.(name, {
                                    type: 'manual',
                                    message: 'First Name must not exceed 50 characters',
                                });
                            } else {
                                setError?.(name, null);
                            }
                            return true;
                        }
                    }}
                    value={textValue}
                    placeholder={placeholder}
                    className='input-grc flex h-9 w-[95%] rounded-lg ring-[1.5px] ring-[hsl(var(--border))] border-none bg-transparent pl-[85px] pr-3 text-sm shadow-sm transition-colors file:border-1 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:border-none focus-visible:outline-none focus-visible:ring-[1.5px] focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50'
                    type='text'
                    />
                )}
            />
            <div className='w-[78px] absolute top-0'>
                <Select
                value={dropdownValue || ''}
                defaultValue={dropdownValue || ''}
                disabled={disabled}
                onValueChange={value => onChangeValue(value, true)}>
                    <SelectTrigger className='dropdown-text-select ring-[transparent] focus:ring-[transparent] pr-1'>
                        <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="Mr. ">Mr.</SelectItem>
                        <SelectItem value="Mrs. ">Mrs.</SelectItem>
                        <SelectItem value="Ms. ">Ms.</SelectItem>
                        <SelectItem value="Mx. ">Mx.</SelectItem>
                        <SelectItem value="Dr. ">Dr.</SelectItem>
                    </SelectContent>
                </Select>
            </div>
            <p className='grc-error-msg text-danger'>{errors && name && errors[name]?.message}</p>
        </div>
    </Fragment>
  )
}

DropdownTextInput.propTypes = {
    value: PropTypes.string,
    onValueChange: PropTypes.func,
    name: PropTypes.string,
    control: PropTypes.any,
    rules: PropTypes.object,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    errors: PropTypes.any,
    label: PropTypes.string,
    setError: PropTypes.func,
    clearErrors: PropTypes.func,
}

export default DropdownTextInput